// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewsDetail_wrapper__35vWe","pageHeader":"NewsDetail_pageHeader__3Ebw2"};